import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
const Fee_details = () => {
  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Fee Details" breadcrumbName="Fee Structure" />
      <div className="container body_height">
        <div className="row">
          <div className="col-md-12">
            <iframe
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/pdf/Mandatory/fee-structure.pdf"
              width="100%"
              height="700"
              title="Fee Structure"
            ></iframe>
            {/* <iframe
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/pdf/monthly_fee_str.pdf"
              width="100%"
              height="700"
              title="Fee Structure"
            ></iframe> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Fee_details;
